
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import store from "./state/store";
import { vMaska } from "maska";
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import CKEditor from '@ckeditor/ckeditor5-vue';
import BootstrapVueNext from 'bootstrap-vue-next';

import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import "@vueform/multiselect/themes/default.css"
import './assets/scss/app.scss';

import 'vue3-toastify/dist/index.css';




// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);
var baseUrl = (process.env.VUE_APP_ENV == 'local' ? 'http://localhost:3000' : window.location.origin);
store.commit('setApiUrl', `${baseUrl}/api`);
store.commit('setVersion', process.env.VUE_APP_VERSION);
store.commit('setEnv', process.env.VUE_APP_ENV);
store.commit('setVersion', process.env.VUE_APP_VERSION);

import VueMask from '@devindex/vue-mask';


import axios from 'axios';
axios.get('https://www.cloudflare.com/cdn-cgi/trace').then(function (data) {
    try { 
        let ip = data.data.split('ip=')[1].split('\n')[0].trim();
        store.commit('setIP', ip);
    } catch{
        console.error('Error to set iP');
    }   
});

if(store.state.session.env != 'local'){
    try {
        axios.get('https://ipapi.co/json/').then(function (data) {
            try { 
                store.commit('setIPState', data.data.region_code);
                store.commit('setIPCity', data.data.city);
            } catch{
                console.error('Error to set iP');
            }   
        });

    } catch{
        console.error(`Errow while get CIY`);
    }
}
const key = process.env.VUE_APP_KEY || 'nokey';
const logged = !(!localStorage.getItem(`${key}-login`));

store.commit('setDebug', localStorage.getItem(`${key}-debug`) == 'true');
if(logged){
    const jwtPayload = UtilMixing.parseJwt((localStorage.getItem(`${key}-login`)));
    if(jwtPayload){
        const refreshToken = JSON.parse(localStorage.getItem(`${key}-login`)).refreshToken;
        const jwt = JSON.parse(localStorage.getItem(`${key}-login`)).jwt;
        const sessionId = JSON.parse(localStorage.getItem(`${key}-login`)).sessionId;
        store.commit('setLogin', { jwt, refreshToken, sessionId });
        store.commit('setUserRole', jwtPayload.role);
        if(jwtPayload.role != 'ADMIN'){ 
            store.commit('setDebug', false);   
            localStorage.setItem(`${key}-debug`, false);
        }
    }
} else {
    store.commit('setLoaded', true);
}
import {  httpCore } from './mixings/http.js'

if(store.state.session.env != 'local'){
    window.setInterval(function(){
        var logged = !(!localStorage.getItem(`${key}-login`));
        if(logged){
            httpCore.post(`/session/ping/?refreshToken=`).then(function(){ console.log(`Ping succesfully`);}).catch(function(){ console.error(`Error while track the session End`)})
        }
    }, 20000);
}
import "primeflex/primeflex.css";
import 'primevue/resources/themes/lara-light-teal/theme.css'
import "primevue/resources/primevue.min.css";
import PrimeVue from 'primevue/config';
import UtilMixing from './mixings/UtilMixing';
import Maska from 'maska'


import { Money3Component } from 'v-money3'
var app = createApp(App);
var sentryyEnabled = true;//process.env.VUE_SENTRY_ENABLED == 'true' ? true : false;
var sentryDsn = "https://45c4ec7dd5051049b1799a0ba7a320ee@o4512063376785408.ingest.us.sentry.io/4512069634883584";//process.env.VUE_SENTRY_DSN ? process.env.VUE_SENTRY_DSN: undefined;
import * as Sentry from "@sentry/vue";
if(sentryyEnabled && sentryDsn){
    Sentry.init({
    app,
    dsn: sentryDsn,
    integrations: [
        Sentry.browserTracingIntegration({ router })
    ],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    initialScope: {
        tags: {
        type: 'web',
        service: process.env.VUE_APP_ENV,
        },
    },
    });
}

import AutoComplete from 'primevue/autocomplete';
app.component('AutoComplete', AutoComplete);
app.use(store)
app.use(Maska)
app.use(router)
app.component("money3", Money3Component)
app.use(PrimeVue)
app.use(VueApexCharts)
app.use(BootstrapVueNext)
app.use(i18n)
app.directive("maska", vMaska)
app.use(CKEditor)
app.use(VueMask)
app.use(vClickOutside)

import { useAccordion } from "vue3-rich-accordion";
import "./assets/scss/accordion-styles.scss";
app.use(useAccordion);

import vue3Leaflet from 'vue3-leaflet';
app.use(vue3Leaflet);

import VueSignaturePad from 'vue-signature-pad';
app.use(VueSignaturePad);

import VueQrcodeReader from 'vue-qrcode-reader'
app.use(VueQrcodeReader)

import  currency  from 'currency.js'
app.config.globalProperties.$filters = {

    companyAllowFutureInvoice(){
        try{
            return store.state.session.companyAllowFutureInvoice == true;
        } catch{
            return false;
        }
    }, 
    allowFutureInvoice(){
        try{
            return store.state.session.allowFutureInvoice == true;
        } catch{
            return false;
        }
    },  
    isProd(){
        try{
            return window.location.origin.includes('app.transferporto')
        } catch{
            return false;
        }
    },  
    isDebug(){
        try{
            return store.state.session.debug
        } catch{
            return false;
        }
    },
    isFinancial(){
        try{
            return store.state.session.role == 'FINANCIAL';
        } catch{
            return false;
        }
    },
    isUser(){
        try{
            return store.state.session.role == 'USER';
        } catch{
            return false;
        }
    },
    isLimitedView(){
        try{        
            var ret=  store.state.session.limitedView || false;
            console.log('r'+ret);
            return ret
        } catch{
            return false;
        }
    },
    isAdmin(){
        try{
            return store.state.session.role == 'ADMIN';
        } catch{
            return false;
        }
    },
    stringToMoney(amount) {
        try {
            var amountParsed =  parseFloat(amount.replace(/R\$/g, "").replace(/\./, "").replace(/,/g, ".").trim());
            return isNaN(amountParsed) ? 0 : amountParsed;
        } catch {
            return 0;
        }
    },
    
    toCurrency(value) {
        var valor = value;
  
        if(valor == null) 
          valor = 0;
      
        if (typeof valor !== "number") {
            value = parseFloat(value);
            if(isNaN(value)) 
              return value;
        }
        const REAL = value => currency(value, { symbol: 'R$ ', decimal: ',', separator: '.' });
        return REAL(value).format();
    },
    
    toPercentage(value) {
        var valor = value;
        valor = parseFloat(valor || 0);
        if(valor == null || valor == undefined) 
          valor = 0;
        return `${valor}%`;
    },
    formatDocument(value) {
        if(UtilMixing.isCnpjValid(value)){
             return UtilMixing.formatCnpj(value);
        } else if (UtilMixing.isCpfValid(value)){
            return UtilMixing.formatCpf(value);
        }  else{
            return value;
        }
    },
}

//CHARTS
import HighchartsVue from 'highcharts-vue'

//import './registerServiceWorker'
app.use(HighchartsVue, {tagName: 'charts'})

app.mount('#app');